import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";

const apiUrl = environment.apiUrl;

export interface HealthStatus {
  status: string;
  version: string;
  timestamp: Date;
}

@Injectable({
  providedIn: "root",
})
export class HealthService {
  constructor(private http: HttpClient) {}

  public getHealthStatus(): Observable<HealthStatus> {
    return this.http.get<HealthStatus>(`${apiUrl}/health`);
  }
}
